import { getBaseURL, getPrivateApi } from "../lib/axiosConfig";
import { Receipt, TotemOrder, TotemTransaction, TransactionError, TransactionReturn, WashingOption } from "../types/washing.types";
import { AppError } from "./classes";
import { retry } from "./generic";

const api = getPrivateApi();

export const getWashingTypesByStation = async (station: string): Promise<WashingOption[]> => {
  try {
    const { data } = await api.get(`/washing-types/station/${station}`);

    if(!data || data.length === 0) {
      const errMsg = "Erro ao buscar tipos de lavação.";
      console.error(errMsg);
      throw new AppError(errMsg, 500);
    }

    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar tipos de lavação.";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
};

export const createTotemTransaction = async (payload: TotemTransaction): Promise<TransactionReturn | TransactionError> => {
  const { amount, paymentType, totemId } = payload;
  const normalizedValue = Math.round(Number(amount) * 100).toString();
  try {
    const response = await api.post(
      `/totem/transaction`,
      {
        totemId,
        appType: paymentType,
        amount: normalizedValue,
      }
    );
    console.log('Transação criada com sucesso:', response.data);
    return { success: true, data: response.data };
  } catch (error: any) {
    console.error('Erro ao criar transação:', error?.response?.data || error.message);
    return { success: false, error: error?.response?.data || error.message };
  }
};

export const createTotemOrder = async (payload: TotemOrder) => {
  const { washingTypeId, washingTypePrice, licencePlate, paymentType, taxId, totemId, cieloTransactionId } = payload;
  try {
    const response = await api.post(
      `/washing-orders`,
      {
        washingType: {
          id: washingTypeId,
          price: washingTypePrice,
        },
        licencePlate,
        paymentType,
        taxId,
        totemId,
        cieloTransactionId,
      }
    );
    console.log('Ordem criada com sucesso:', response.data);
  } catch (error: any) {
    console.error('Erro ao criar ordem:', error?.response?.data || error.message);
  }
};

export const sendReceipt = async (receipt: Receipt): Promise<void> => {
  try {
    await retry(() =>
      api.post(`/receipts/send`, receipt), 3, 2000
    );
  } catch (error: any) {
    const errMsg = "Erro ao enviar recibo";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
}
